'use client'

import Image from 'next/image'
import { useTheme } from '@/app/[locale]/ThemeProvider'
import SpaceIconWhite from '@/public/SpaceIcon3White.svg'
import SpaceIconAbyss from '@/public/SpaceIcon3Abyss.svg'

interface ProductImageProps {
  src: string
  alt: string
  className?: string
  sizes?: string
}

export default function ProductImage({ src, alt, className, sizes }: ProductImageProps) {
  const { theme } = useTheme()

  return (
    <div className="relative w-full h-full">
      <Image
        src={src}
        alt={alt}
        fill
        loading="lazy"
        className={className}
        sizes={sizes}
      />
      <div className="absolute top-4 right-4 w-12 h-12">
        <Image
          src={theme === 'dark' ? SpaceIconWhite : SpaceIconAbyss}
          alt="Space Icon"
          width={48}
          height={48}
          className="w-full h-full"
        />
      </div>
    </div>
  )
} 